import React from 'react';

import { Spacer } from '@zillow/constellation';

import { StyledErrorText } from 'app/shared/components/Wizard/PhoneVerificationWizard/StyledComponents';
import { StyledLink } from './StyledComponents';

const MaxAttemptsError = () => (
    <Spacer marginTop="sm">
        <StyledErrorText
            as="div"
            fontType="smallbody"
        >
            You have exceeded the maximum verification attempts for this number.
            {' Please provide a different phone number or '}
            <StyledLink
                target="_blank"
                to="https://help.zillowrentalmanager.com/hc/en-us/requests/new"
            >
                contact customer support.
            </StyledLink>
        </StyledErrorText>
    </Spacer>
);

export default MaxAttemptsError;
